export function capitalize(str) {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1, str.length);
}

export function patientFullName(input) {
  const {firstName='', middleInitial='', lastName=''} = input;
  return firstName + ' ' + (middleInitial? middleInitial + ' ' : '') + lastName;
}

export function patientInitials(input) {
  input = Object.assign({firstName: '', lastName: ''}, input);
  return input.firstName.charAt(0) + ' ' + input.lastName.charAt(0);
}

export function dateTimeStr(input) {
  if (!input) return ''
  const date = new Date(input)
  return date.toLocaleString()
}



// WEBPACK FOOTER //
// ./src/app/filters/filters.js